export default __webpack_public_path__ + "static/rongyi-e4d95bee48d886ad42ce62dc1bcf492b.jpg";